window.addEventListener('load', () => {
  modalQueryMap();
});

function modalQueryMap() {
  if (document.querySelector('.js-modalClose')) {
    const bodyEle = document.querySelector('body');
    const modalMap = document.querySelector('.js-modalMap');
    const modalMapBody = document.querySelector('.js-modalMapBody');
    const modalClose = document.querySelector('.js-modalClose');
    const modalGmapTrigger = document.querySelectorAll('.js-modalGmapTrigger');
    const modalGmapTriggerList = Array.prototype.slice.call(modalGmapTrigger, 0);


    modalGmapTriggerList.forEach((targetBox) => {
      targetBox.addEventListener('click', () => {
        // マップ情報取得 + 設定
        const gmapData = targetBox.getAttribute('data-gmap');
        const gmapDataSplit = gmapData.split(',');
        const gmapDataLatitude = gmapDataSplit[0];
        const gmapDataLongitude = gmapDataSplit[1];

        // マップDOM生成
        const mapCont = document.createElement('div');
        mapCont.className = 'c-modalMap_bodyInner';
        mapCont.innerHTML = '<div class="c-modalMap_frame js-modalMapFrame"><iframe src="https://maps.google.co.jp/maps?q=' + gmapDataLatitude + ',' + gmapDataLongitude + '&output=embed&t=m&z=16&hl=ja" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div><p class="c-modalMap_link"><a href="https://www.google.com/maps/?q=' + gmapDataLatitude + ',' + gmapDataLongitude + '" target="_blank" class="c-modalMap_linkItem c-linkText"><span class="c-linkText_inner">Google マップで見る</span></a></p>';
        modalMapBody.appendChild(mapCont);

        // マップ表示
        bodyEle.classList.add('is-fixed');
        modalMap.classList.add('is-view');
      });
    });

    if (document.querySelector('.js-modalClose')) {
      modalClose.addEventListener('click', () => {
        const modalMapFrame = document.querySelector('.c-modalMap_bodyInner');
        modalMapBody.removeChild(modalMapFrame);

        bodyEle.classList.remove('is-fixed');
        modalMap.classList.remove('is-view');
      });
    }
  }
}
